import { Footprints, Mountain, Bike, Waves, Activity, Dumbbell } from "lucide-react";

const MAP = {
  running: Footprints, "trail-running": Mountain, cycling: Bike,
  triathlon: Waves, duathlon: Activity, "fitness-racing": Dumbbell,
};

export function SportIcon({ sport, ...props }) {
  const Icon = MAP[sport] || Footprints;
  return <Icon {...props} />;
}
